import { render } from "./NewContent.page.vue?vue&type=template&id=da9b857e&scoped=true&ts=true"
import script from "./NewContent.page.vue?vue&type=script&lang=ts"
export * from "./NewContent.page.vue?vue&type=script&lang=ts"

import "./NewContent.page.vue?vue&type=style&index=0&id=da9b857e&lang=scss&scoped=true"

import exportComponent from "/builds/anisen/datamanagerweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da9b857e"]])

export default __exports__